import { createSlice } from "@reduxjs/toolkit";

export const tldSlice = createSlice({
  name: 'tld',
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startTld: (state) => { state.isLoading = true; },
    setTld: (state, { payload: { data, error }}) => { 
      state.data = data ?? null;
      state.error = error ?? null;
      state.isLoading = false;
    }
  }
});

export const { startTld, setTld } = tldSlice.actions;
